import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import cx from "classnames";

import Link, { linkTo } from "../../../Link";
import { CustomI18nextContext } from "../../../../contexts/CustomI18nextContext";

const CompanyMenu = ({ isActive }) => {
  const { t } = useTranslation();
  const { lang } = useContext(CustomI18nextContext);

  const zipmexlabsAvailable = ["th_en", "id_en", "au", "en"].includes(lang);
  const zipmexlabsLink = `https://zipmex.com${linkTo(lang, "/zipmexlabs/")}`;

  return (
    <div
      id="sub-menu__company"
      className={cx(
        "container sub-menu sub-menu__company row ",
        { active: isActive },
        { inactive: !isActive }
      )}
    >
      <div className="col mx-1 mx-xl-3 mt-5">
        <h5>{t("menu.company.content.title")}</h5>
        <span>{t("menu.company.content.description")}</span>
      </div>
      <div className="col-8 mx-1 mx-xl-3 mt-5">
        <div className="row">
          <div className="col-3">
            <span className="title">{t("menu.company.getStarted.title")}</span>
            <div className="mt-3">
              <Link to={`/about-us/`}>
                <h6 className="mb-4 pb-2">
                  {t("menu.company.getStarted.aboutUs")}
                </h6>
              </Link>
              <Link to={`https://zipmex.bamboohr.com/jobs/`}>
                <h6 className="mb-4 pb-2">
                  {t("menu.company.getStarted.careers")}
                </h6>
              </Link>
              <Link to={`/contact-us/`}>
                <h6 className="mb-4 pb-2">
                  {t("menu.company.getStarted.contactUs")}
                </h6>
              </Link>
              {zipmexlabsAvailable ? (
                <a href={zipmexlabsLink} target="_blank">
                  <h6 className="mb-4 pb-2">
                    {t("menu.company.getStarted.zipmexlabs")}
                  </h6>
                </a>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="col-4">
            <span className="title">{t("menu.company.updates.title")}</span>
            <div className="mt-3">
              <Link to={`/news/`}>
                <h6 className="mb-4 pb-2">{t("menu.company.updates.news")}</h6>
              </Link>
              <Link to={`/announcements/`}>
                <h6 className="mb-4 pb-2">
                  {t("menu.company.updates.announcements")}
                </h6>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyMenu;
